/* ============================================================
   Long Run Co. Member Portal USAGE QUIZ v2.1
   Reads window.LRCMP_QUIZ (sections/lrc-mp-quiz.liquid), renders a
   stepped flow into the engine modal [data-modal="quizModal"], and
   persists to the Vercel backend (/apps/lrc):
     save_usage_rate -> usage: { <key>:{uses,...}, meta:{cadence} }
     get_member      -> { member:{ usage:{...} } } (prefill)
   No auto-advance: tiles select only; steppers for count questions;
   a footer holds Back (quiet, bottom-left) and Next (primary,
   bottom-right). ONE education card before results recommends a
   category the customer does not use. Registers LRCMP.openQuiz.
   No em or en dashes in copy.
   ============================================================ */
(function () {
  "use strict";

  /* ---------- DOM + helpers ---------- */
  function rootEl() { return document.querySelector("[data-lrc-member-portal]"); }
  function modalEl() { var r = rootEl(); return r ? r.querySelector('[data-modal="quizModal"]') : null; }
  function bodyEl() { var m = modalEl(); return m ? m.querySelector('[data-mp-region="quiz-body"]') : null; }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function num(v) { var n = parseFloat(v); return isNaN(n) ? null : n; }
  function clone(o) { try { return JSON.parse(JSON.stringify(o)); } catch (e) { return {}; } }
  function cfg() { return window.LRCMP_QUIZ || null; }
  function normKey(k) { k = String(k || "").trim(); return k === "caffyne" ? "pouches" : (k || "category"); }
  function intMin1(v, dflt) { var n = Math.round(num(v) == null ? dflt : num(v)); return n < 1 ? 1 : n; }

  /* Data-driven coffee-method route from the "Label|kind|factor" line. Routes by the kind token first, then
     falls back to inferring from the label. Returns "drip" | "french_press" | "percup". The default for any
     unrecognized or blank kind is ALWAYS "percup" (cups/day) so a method NEVER lands on the drip pot question. */
  function methodRoute(label, kind) {
    var k = String(kind || "").toLowerCase().replace(/[^a-z]/g, "");
    var l = String(label || "").toLowerCase();
    if (k === "drip" || k === "batch" || k === "dripcoffeemaker") return "drip";
    if (k === "frenchpress" || k === "fp" || k === "press") return "french_press";
    if (k === "percup" || k === "cups" || k === "cup" || k === "pourover" || k === "espresso" || k === "moka" || k === "espressomoka" || k === "espressoormoka" || k === "pods" || k === "pod" || k === "singleserve" || k === "singleservepod" || k === "keurig" || k === "nespresso" || k === "capsule") return "percup";
    /* fallback: infer from the display label when the kind token is missing or unrecognized */
    if (l.indexOf("drip") >= 0) return "drip";
    if (l.indexOf("french") >= 0) return "french_press";
    return "percup";   /* default, never drip */
  }

  /* "Label|value" per line -> [{ label, raw, raw2 }] */
  function parseLines(str) {
    var out = [];
    String(str == null ? "" : str).split("\n").forEach(function (line) {
      var t = line.replace(/\r$/, "").trim(); if (!t) return;
      var p = t.split("|");
      out.push({ label: (p[0] || "").trim(), raw: (p[1] == null ? "" : p[1]).trim(), raw2: (p[2] == null ? "" : p[2]).trim() });
    });
    return out;
  }

  /* ---------- backend ---------- */
  function postLRC(payload) {
    return fetch("/apps/lrc", {
      method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
    }).then(function (r) { return r.json().catch(function () { return null; }); });
  }

  /* ---------- config normalization ---------- */
  function normCat(c) {
    var o = {
      kind: c.kind, key: normKey(c.key), label: c.label || "", unitNoun: c.unitNoun || "bags",
      unitsPerBag: (num(c.unitsPerBag) && num(c.unitsPerBag) > 0) ? num(c.unitsPerBag) : (c.kind === "coffee" ? 31 : 30),
      countDefault: intMin1(c.countDefault, 2),
      gate: c.gateQuestion || "Do you use this?", yes: c.yesLabel || "Yes", no: c.noLabel || "No",
      edu: c.edu || {}
    };
    if (c.kind === "coffee") {
      o.methodTitle = c.methodTitle || "";
      /* "Label|kind|factor" per line: kind routes (drip / french_press / percup); factor is field 3 (default 1.0).
         Drip ignores the factor. percup: servingsPerDay = cupsPerDay * factor. french_press: cups * factor * (perWeek/7). */
      o.methods = parseLines(c.methodOptions).map(function (x) {
        var factor = (num(x.raw2) && num(x.raw2) > 0) ? num(x.raw2) : 1.0;
        return { label: x.label, route: methodRoute(x.label, x.raw), factor: factor };
      });
      o.potTitle = c.potTitle || ""; o.pots = parseLines(c.potOptions).map(function (x) { return { label: x.label, servings: num(x.raw) || 1 }; });
      o.freqTitle = c.freqTitle || ""; o.freqs = parseLines(c.freqOptions).map(function (x) { return { label: x.label, perWeek: num(x.raw) || 0 }; });
      o.cupsTitle = c.cupsTitle || ""; o.fpTitle = c.fpTitle || "";
      /* coffee has TWO education slides + a regular-use threshold (days/week) */
      o.eduNotUse = c.eduNotUse || {};
      o.eduIrregular = c.eduIrregular || {};
      o.regularThreshold = (num(c.regularThreshold) && num(c.regularThreshold) > 0) ? num(c.regularThreshold) : 5;
    } else {
      o.discreteTitle = c.discreteTitle || "";
    }
    return o;
  }
  function cadenceList() {
    var out = []; String((cfg() && cfg().cadenceOptions) || "30,45,60,75,90").split(",").forEach(function (x) { var n = num(x); if (n && n > 0) out.push(Math.round(n)); });
    return out.length ? out : [30, 45, 60, 75, 90];
  }

  /* ---------- state + nav ---------- */
  var Q = null; /* { cats, answers, nav:[descriptor], chosenCadence } */
  function go(desc) { Q.nav.push(desc); render(); }
  function back() { if (Q.nav.length > 1) { Q.nav.pop(); render(); } }
  function cur() { return Q.nav[Q.nav.length - 1]; }

  function finalize(ci) {
    var cat = Q.cats[ci], a = Q.answers[cat.key];
    if (!a || !a.uses) return;
    if (cat.kind === "coffee") {
      if (a.methodRoute === "drip") a.servingsPerDay = (num(a.potServings) || 0) * ((num(a.perWeek) || 0) / 7);
      else if (a.methodRoute === "french_press") a.servingsPerDay = (num(a.fpCups) || 0) * (num(a.methodFactor) || 1) * ((num(a.perWeek) || 0) / 7);
      else a.servingsPerDay = (num(a.cupsPerDay) || 0) * (num(a.methodFactor) || 1) * ((num(a.perWeek) || 0) / 7);
    } else {
      a.servingsPerDay = (num(a.perWeek) || 0) / 7;
    }
  }
  function afterCategory(ci) { finalize(ci); if (ci + 1 < Q.cats.length) go({ t: "gate", ci: ci + 1 }); else preResults(); }

  /* recommend the first category the customer does NOT use; if all used, skip the card */
  /* ONE card max, in block order. Coffee: fires on uses===false (not-use slide) OR uses && perWeek < threshold
     (irregular slide). Caffyne/tea: fires only on uses===false. Returns { ci, edu } or null. */
  function pickRecommend() {
    for (var i = 0; i < Q.cats.length; i++) {
      var cat = Q.cats[i], a = Q.answers[cat.key] || {};
      if (cat.kind === "coffee") {
        if (a.uses === false) return { ci: i, edu: cat.eduNotUse };
        if (a.uses === true && (num(a.perWeek) || 0) < cat.regularThreshold) return { ci: i, edu: cat.eduIrregular };
        /* regular coffee drinker: coffee fires nothing, continue */
      } else {
        if (a.uses === false) return { ci: i, edu: cat.edu };
      }
    }
    return null;
  }
  function preResults() { var rec = pickRecommend(); if (rec) go({ t: "educard", ci: rec.ci, edu: rec.edu }); else openResults(); }

  /* ---------- render scaffolding ---------- */
  function setBody(html) { var b = bodyEl(); if (b) b.innerHTML = html; }
  function qa(sel) { var b = bodyEl(); return b ? Array.prototype.slice.call(b.querySelectorAll(sel)) : []; }
  function qsel(sel) { var b = bodyEl(); return b ? b.querySelector(sel) : null; }

  function beaconStyle() { var col = (cfg() && cfg().beaconColor) || "#BC5530"; return 'style="--quiz-beacon:' + esc(col) + '"'; }
  function eyebrow(txt) { return txt ? '<div class="quiz-eyebrow" ' + beaconStyle() + ">" + esc(txt) + "</div>" : ""; }
  function question(txt) { return '<h3 class="quiz-q">' + esc(txt) + "</h3>"; }

  /* shell: content (top eyebrow lives in content) + footer. Footer inner is built per screen. */
  function shell(contentHTML, footerInner) {
    setBody('<div class="quiz-content">' + contentHTML + "</div>" + '<div class="quiz-foot">' + (footerInner || "") + "</div>");
    var bk = qsel("[data-back]"); if (bk) bk.addEventListener("click", back);
  }
  /* Back (quiet, bottom-left) + Next (primary, bottom-right; not full-width) */
  function footRow(nextLabel, enabled) {
    var bk = (Q.nav.length > 1) ? '<button type="button" class="quiz-back-link" data-back>' + "‹ Back</button>" : "<span></span>";
    return '<div class="quiz-foot-row">' + bk + '<button type="button" class="btn btn-primary quiz-next" data-next ' + (enabled ? "" : "disabled") + ">" + esc(nextLabel || "Next") + "</button></div>";
  }
  function tiles(items, selIdx) {
    return '<div class="quiz-tiles">' + items.map(function (it, i) {
      return '<button type="button" class="quiz-tile' + (i === selIdx ? " sel" : "") + '" data-opt="' + i + '">' + esc(it.label) + "</button>";
    }).join("") + "</div>";
  }
  function bindTiles(onPick) { qa("[data-opt]").forEach(function (el) { el.addEventListener("click", function () { onPick(num(el.getAttribute("data-opt"))); }); }); }
  function bindNext(fn) { var n = qsel("[data-next]"); if (n && !n.disabled) n.addEventListener("click", fn); }

  /* ---------- screens ---------- */
  function render() {
    var d = cur();
    if (d.t === "intro") return renderIntro();
    if (d.t === "gate") return renderGate(d.ci);
    if (d.t === "method") return renderMethod(d.ci);
    if (d.t === "pot") return renderPot(d.ci);
    if (d.t === "freq") return renderFreq(d.ci);
    if (d.t === "cups") return renderCups(d.ci);
    if (d.t === "fpcups") return renderFpCups(d.ci);
    if (d.t === "discrete") return renderDiscrete(d.ci);
    if (d.t === "educard") return renderEduCard(d);
    if (d.t === "results") return renderResults();
  }

  function renderIntro() {
    var intro = (cfg().intro) || {};
    /* intro CTA is FULL WIDTH (step screens use the Back + Next footer row) */
    shell(eyebrow(intro.eyebrow) + question(intro.title || "How much do you use?") + (intro.body ? "<p>" + esc(intro.body) + "</p>" : ""),
      '<button type="button" class="btn btn-primary btn-block" data-next>Begin</button>');
    bindNext(function () { go({ t: "gate", ci: 0 }); });
  }

  function renderGate(ci) {
    var cat = Q.cats[ci], a = Q.answers[cat.key] || {};
    var sel = (a.uses === true) ? 0 : (a.uses === false ? 1 : -1);
    shell(eyebrow(cat.label) + question(cat.gate) + tiles([{ label: cat.yes }, { label: cat.no }], sel), footRow("Next", sel !== -1));
    bindTiles(function (i) { Q.answers[cat.key] = Q.answers[cat.key] || {}; Q.answers[cat.key].uses = (i === 0); renderGate(ci); });
    bindNext(function () {
      if (Q.answers[cat.key].uses) { go({ t: cat.kind === "coffee" ? "method" : "discrete", ci: ci }); }
      else { afterCategory(ci); }   /* No: store {uses:false} and move on; recommendation happens once, before results */
    });
  }

  /* The ONE selection handler each tap fires: resolves the option to its stored fields (method -> kind+factor that
     the router reads). The seed below calls this exact function on the default option, so an untapped default
     populates kind/factor/state identically to a tap (never a blank that falls through to the percup default). */
  function selectMethod(ci, i) { var cat = Q.cats[ci], m = cat.methods[i], aa = (Q.answers[cat.key] = Q.answers[cat.key] || {}); aa.method = m.label; aa.methodRoute = m.route; aa.methodFactor = m.factor; }
  function selectPot(ci, i) { var cat = Q.cats[ci]; (Q.answers[cat.key] = Q.answers[cat.key] || {}).potServings = cat.pots[i].servings; }
  function selectFreq(ci, i) { var cat = Q.cats[ci]; (Q.answers[cat.key] = Q.answers[cat.key] || {}).perWeek = cat.freqs[i].perWeek; }

  function renderMethod(ci) {
    var cat = Q.cats[ci], a = (Q.answers[cat.key] = Q.answers[cat.key] || {});
    var sel = -1; cat.methods.forEach(function (m, k) { if (m.label === a.method) sel = k; });
    if (sel === -1 && cat.methods.length) sel = 0;   /* sub-question: default to the first option when nothing valid is stored */
    if (sel !== -1) selectMethod(ci, sel);           /* ALWAYS (re)resolve kind+factor from current config via the tap path, overwriting any stale prefilled route */
    shell(eyebrow(cat.label) + question(cat.methodTitle) + tiles(cat.methods, sel), footRow("Next", sel !== -1));
    bindTiles(function (i) { selectMethod(ci, i); renderMethod(ci); });
    bindNext(function () { var r = Q.answers[cat.key].methodRoute; go({ t: r === "drip" ? "pot" : (r === "french_press" ? "fpcups" : "cups"), ci: ci }); });
  }
  function renderPot(ci) {
    var cat = Q.cats[ci], a = (Q.answers[cat.key] = Q.answers[cat.key] || {});
    var sel = -1; cat.pots.forEach(function (p, k) { if (p.servings === a.potServings) sel = k; });
    if (sel === -1 && cat.pots.length) sel = 0;
    if (sel !== -1) selectPot(ci, sel);
    shell(eyebrow(cat.label) + question(cat.potTitle) + tiles(cat.pots, sel), footRow("Next", sel !== -1));
    bindTiles(function (i) { selectPot(ci, i); renderPot(ci); });
    bindNext(function () { go({ t: "freq", ci: ci }); });
  }
  function renderFreq(ci) {
    var cat = Q.cats[ci], a = (Q.answers[cat.key] = Q.answers[cat.key] || {});
    var sel = -1; cat.freqs.forEach(function (f, k) { if (f.perWeek === a.perWeek) sel = k; });
    if (sel === -1 && cat.freqs.length) sel = 0;
    if (sel !== -1) selectFreq(ci, sel);
    shell(eyebrow(cat.label) + question(cat.freqTitle) + tiles(cat.freqs, sel), footRow("Next", sel !== -1));
    bindTiles(function (i) { selectFreq(ci, i); renderFreq(ci); });
    bindNext(function () { afterCategory(ci); });
  }

  /* count questions = stepper (integer, min 1). Initializes from the block's configured starting count
     (count_default) on first entry per field, so the editor value is respected (not a hardcoded number). */
  function stepperScreen(ci, field, title, onNext) {
    var cat = Q.cats[ci], a = Q.answers[cat.key];
    var flag = "_init_" + field;
    if (!a[flag]) { a[field] = cat.countDefault; a[flag] = true; }
    if (num(a[field]) == null || num(a[field]) < 1) a[field] = cat.countDefault;
    function paint() {
      var v = intMin1(a[field], cat.countDefault); a[field] = v;
      shell(
        eyebrow(cat.label) + question(title) +
        '<div class="quiz-stepper"><button type="button" class="quiz-step-btn" data-dec aria-label="Decrease">−</button>' +
        '<div class="quiz-stepval" data-val>' + v + "</div>" +
        '<button type="button" class="quiz-step-btn" data-inc aria-label="Increase">+</button></div>',
        footRow("Next", true)
      );
      var dec = qsel("[data-dec]"); if (dec) dec.addEventListener("click", function () { a[field] = Math.max(1, v - 1); paint(); });
      var inc = qsel("[data-inc]"); if (inc) inc.addEventListener("click", function () { a[field] = v + 1; paint(); });
      bindNext(function () { onNext(); });
    }
    paint();
  }
  function renderCups(ci) { stepperScreen(ci, "cupsPerDay", Q.cats[ci].cupsTitle, function () { go({ t: "freq", ci: ci }); }); }
  function renderFpCups(ci) { stepperScreen(ci, "fpCups", Q.cats[ci].fpTitle, function () { go({ t: "freq", ci: ci }); }); }
  function renderDiscrete(ci) { stepperScreen(ci, "perWeek", Q.cats[ci].discreteTitle, function () { afterCategory(ci); }); }

  /* ---------- single education card (before results) ---------- */
  function renderEduCard(d) {
    var e = (d && d.edu) || {}, c = (cfg().edu) || {};
    var callouts = (e.callouts || []).filter(function (x) { return x && (x.label || x.proof); });
    var coHTML = callouts.length ? '<div class="quiz-callouts">' + callouts.map(function (x) {
      var icon = x.icon ? '<img class="quiz-co-icon" src="' + esc(x.icon) + '" alt="" loading="lazy">' : '<span class="quiz-co-icon" style="background:' + esc(c.accent || "#EFD5C5") + '"></span>';
      return '<div class="quiz-co">' + icon + '<div class="quiz-co-txt"><div class="quiz-co-label">' + esc(x.label || "") + "</div>" +
        (x.proof ? '<div class="quiz-co-proof">' + esc(x.proof) + "</div>" : "") + "</div></div>";
    }).join("") + "</div>" : "";
    var band = e.image ? '<div class="quiz-edu-band"><img src="' + esc(e.image) + '" alt="" loading="lazy"></div>' : "";
    var cardStyle = 'style="background:' + esc(c.surface || "#223F4E") + ';color:' + esc(c.text || "#FFFFFF") + '"';
    /* eyebrow text + pulsing beacon dot = peach on the navy surface (rust reads muddy); CTA colour lives in the engine CSS */
    var accent = esc(c.accent || "#EFD5C5");
    var backHTML = (Q.nav.length > 1) ? '<button type="button" class="quiz-back-link" data-back>' + "‹ Back</button>" : "";
    shell(
      '<div class="quiz-edu-card" ' + cardStyle + ">" + band +
        '<div class="quiz-edu-body">' +
          '<div class="quiz-eyebrow quiz-edu-eyebrow" style="--quiz-beacon:' + accent + ';color:' + accent + '">' + esc(e.eyebrow || "A Heads Up") + "</div>" +
          '<h3 class="quiz-edu-h" style="color:' + esc(c.heading || "#FFFFFF") + '">' + esc(e.headline || "You may like this in your routine") + "</h3>" +
          (e.body ? "<p>" + esc(e.body) + "</p>" : "") + coHTML +
        "</div>" +
      "</div>",
      '<button type="button" class="btn btn-primary btn-block quiz-edu-cta" data-edu-go>' + esc(e.ctaLabel || "Got It! Let's see my results") + "</button>" + backHTML
    );
    var goBtn = qsel("[data-edu-go]"); if (goBtn) goBtn.addEventListener("click", function () { openResults(); });
  }

  /* ---------- results ---------- */
  function upbOf(cat) { return cat.unitsPerBag; }
  function unitsFor(cat, cadDays) {
    var a = Q.answers[cat.key]; if (!a || !a.uses) return 0;
    var spd = num(a.servingsPerDay) || 0; if (spd <= 0) return 0;
    return Math.max(1, Math.ceil((spd * cadDays) / upbOf(cat)));
  }
  function chooseDefaultCadence(cads) {
    if (Q.chosenCadence && cads.indexOf(Q.chosenCadence) !== -1) return Q.chosenCadence;
    var coffee = null; Q.cats.forEach(function (c) { if (c.kind === "coffee" && Q.answers[c.key] && Q.answers[c.key].uses) coffee = c; });
    if (coffee && (num(Q.answers[coffee.key].servingsPerDay) || 0) > 0) {
      var best = cads[0], bestFrac = 99;
      cads.forEach(function (d) {
        var x = ((num(Q.answers[coffee.key].servingsPerDay) || 0) * d) / upbOf(coffee);
        var frac = Math.abs(x - Math.round(x));
        if (frac < bestFrac - 0.001) { bestFrac = frac; best = d; }
      });
      return best;
    }
    return cads[Math.floor(cads.length / 2)] || cads[0];
  }
  function openResults() {
    var cads = cadenceList();
    if (!Q.chosenCadence) Q.chosenCadence = chooseDefaultCadence(cads);
    go({ t: "results" });
  }
  function renderResults() {
    var c = cfg(), r = c.results || {}, cads = cadenceList();
    if (cads.indexOf(Q.chosenCadence) === -1) Q.chosenCadence = chooseDefaultCadence(cads);
    var pills = '<div class="quiz-cad">' + cads.map(function (d) {
      return '<button type="button" class="quiz-pill' + (d === Q.chosenCadence ? " sel" : "") + '" data-cad="' + d + '">' + d + " days</button>";
    }).join("") + "</div>";
    var sub = (r.subline ? '<div class="quiz-subline">' + esc(r.subline) + "</div>" : "");
    shell(
      eyebrow(r.eyebrow) + question(r.title || "Here's your supply") + (r.body ? "<p>" + esc(r.body) + "</p>" : "") + pills +
      '<div class="quiz-counts" data-counts></div>' + '<div class="quiz-err" data-quiz-err hidden></div>',
      footRow(r.ctaLabel || "Save my answers", true) + sub
    );
    paintCounts();
    qa("[data-cad]").forEach(function (b) { b.addEventListener("click", function () { Q.chosenCadence = num(b.getAttribute("data-cad")); renderResults(); }); });
    var save = qsel("[data-next]"); if (save) save.addEventListener("click", function () { doSave(save); });
  }
  function paintCounts() {
    var host = qsel("[data-counts]"); if (!host) return;
    var rows = Q.cats.filter(function (c) { return Q.answers[c.key] && Q.answers[c.key].uses; }).map(function (c) {
      var n = unitsFor(c, Q.chosenCadence);
      return '<div class="quiz-count-row"><span class="quiz-count-label">' + esc(c.label) + "</span><span class=\"quiz-count-val\">" + n + " " + esc(c.unitNoun) + "</span></div>";
    });
    host.innerHTML = rows.length ? rows.join("") : '<div class="quiz-count-row"><span class="quiz-count-label">No items selected.</span><span></span></div>';
  }

  /* ---------- save ---------- */
  function buildSaveObj(cat) {
    var a = Q.answers[cat.key] || {};
    if (!a.uses) return { uses: false };
    var base;
    if (cat.kind === "coffee") {
      base = { uses: true, method: a.method || "", methodRoute: a.methodRoute || "", servingsPerDay: num(a.servingsPerDay) || 0 };
      if (a.methodRoute === "drip") { base.potServings = num(a.potServings) || 0; base.perWeek = num(a.perWeek) || 0; }
      else if (a.methodRoute === "french_press") { base.fpCups = num(a.fpCups) || 0; base.perWeek = num(a.perWeek) || 0; base.methodFactor = num(a.methodFactor) || 1; }
      else { base.cupsPerDay = num(a.cupsPerDay) || 0; base.methodFactor = num(a.methodFactor) || 1; base.perWeek = num(a.perWeek) || 0; }
    } else {
      base = { uses: true, perWeek: num(a.perWeek) || 0, servingsPerDay: num(a.servingsPerDay) || 0 };
    }
    return base;
  }
  function doSave(btn) {
    var c = cfg();
    var usage = {};
    Q.cats.forEach(function (cat) { usage[cat.key] = buildSaveObj(cat); });
    usage.meta = { cadence: num(Q.chosenCadence) || 0 };   /* numeric leaf inside an object survives the backend depth-2 sanitizer */
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = "Saving...";
    var err = qsel("[data-quiz-err]"); if (err) err.hidden = true;
    postLRC({ action: "save_usage_rate", usage: usage }).then(function (j) {
      if (j && j.ok) {
        btn.textContent = (c.successMsg || "Saved.");
        /* onboarding: backend stamped the 'quiz' item inside save_usage_rate; tell the checklist to re-read now */
        try { document.dispatchEvent(new CustomEvent("lrc:onboarding-changed")); } catch (e) {}
        setTimeout(function () { if (window.LRCMP && LRCMP.close) LRCMP.close("quizModal"); if (window.LRCMP_REFRESH_AFTER_CHANGE) window.LRCMP_REFRESH_AFTER_CHANGE({ member: true }); }, 1500);
      } else {
        if (err) { err.textContent = "Could not save. Please try again."; err.hidden = false; }
        setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2500);
      }
    }).catch(function () {
      if (err) { err.textContent = "Connection issue. Please try again."; err.hidden = false; }
      setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 2500);
    });
  }

  /* ---------- responsive type scale + gap ---------- */
  var _typeBound = false;
  function applyType() {
    var m = modalEl(); if (!m) return;
    var sheet = m.querySelector(".sheet") || m;
    var t = (cfg() && cfg().type) || {};
    var desktop = window.matchMedia && window.matchMedia("(min-width: 750px)").matches;
    function set(varName, mv, dv, fb) { var v = desktop ? (num(dv) || num(mv) || fb) : (num(mv) || fb); sheet.style.setProperty(varName, v + "px"); }
    set("--quiz-eyebrow-fs", t.eyebrowM, t.eyebrowD, 11);
    set("--quiz-title-fs", t.titleM, t.titleD, 21);
    set("--quiz-body-fs", t.bodyM, t.bodyD, 14);
    sheet.style.setProperty("--quiz-gap", (num(cfg() && cfg().gap) || 16) + "px");
    if (!_typeBound && window.matchMedia) {
      _typeBound = true;
      try { window.matchMedia("(min-width: 750px)").addEventListener("change", applyType); }
      catch (e) { try { window.addEventListener("resize", applyType); } catch (e2) {} }
    }
  }

  /* ---------- prefill + open ---------- */
  function openQuiz() {
    var c = cfg();
    if (window.LRCMP && LRCMP.open) LRCMP.open("quizModal");
    applyType();
    if (!c || !c.categories || !c.categories.length) { setBody('<div class="quiz-err">The quiz is not configured yet.</div>'); return; }
    Q = { cats: c.categories.map(normCat), answers: {}, nav: [], chosenCadence: null };
    setBody("<p>Loading...</p>");
    postLRC({ action: "get_member" }).then(function (j) {
      var usage = (j && j.ok && j.member && j.member.usage) || {};
      Q.cats.forEach(function (cat) { if (usage[cat.key] && typeof usage[cat.key] === "object") Q.answers[cat.key] = clone(usage[cat.key]); });
      if (usage.meta && num(usage.meta.cadence)) Q.chosenCadence = Math.round(num(usage.meta.cadence));
      Q.nav = [{ t: "intro" }];
      render();
    }).catch(function () { Q.nav = [{ t: "intro" }]; render(); });
  }

  /* ---------- registration ---------- */
  function register() { if (!window.LRCMP) return false; window.LRCMP.openQuiz = openQuiz; return true; }
  if (!register()) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", register);
    var tries = 0, t = setInterval(function () { tries++; if (register() || tries > 100) clearInterval(t); }, 50);
  }
})();
